import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { IActivity } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { AddWordClassComponent } from '../add-word-class/add-word-class.component';

@Component({
  selector: 'app-add-word-group',
  templateUrl: './add-word-group.component.html',
  styleUrls: ['./add-word-group.component.scss']
})
export class AddWordGroupComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Create new group"
  form: FormGroup;
  name: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  GROUP_KEY: any;
  constructor(
    public dialogRef: MatDialogRef<AddWordGroupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: ActivityStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    const { GROUP, ITEM } = this.data;
    this.GROUP_KEY = GROUP ? GROUP.key : this.ds.createId();
    this.form = this.fb.group({
      name: [GROUP ? GROUP.name : null, Validators.compose([Validators.required])],
    })
    if (GROUP) {
      this.TITLE = "Edit group";
    }
    if (ITEM) {
      const { words } = ITEM;
      this.store.words = words;
    }
  }


  delete(item: any) {
    this.store.options = this.store.options.filter(m => m.key !== item.key) || [];
    this.store.words = this.store.words.filter(m => m.key !== item.key) || [];
  }

  addNewLine(item: any) {
    const { name } = this.form.value;
    let dialogRef = this.dialog.open(AddWordClassComponent, {
      data: {
        GROUP: { key: this.GROUP_KEY, name: name || null, },
        ANSWER: item || null,
      },
      panelClass: 'item-list-panel',
      width: '35wh',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { FORM, SKILL, ACTIVITY_TYPE, MODULE_KEY, ITEM, ACTIVITY_TYPE_OBJECT, SKILL_NAME } = this.data;

      const { name, instruction, defaultInstruction } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const { words } = this.store;

      const groups = ITEM ? ITEM.groups : [];
      const speakerData = { name: `${f.name}`.trim(), key: this.GROUP_KEY };
      const SPEAKER_DATA = pushObjArray(groups || [], speakerData)


      const registerStatus = STATUS_OBJECT.submitted;
      const activity: IActivity = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name || null,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        groups: SPEAKER_DATA,
        words: words || [],
        hasSubActivity: false,
        //modules
        skillKey: SKILL,
        skillRef: this.ds.skillRef().doc(SKILL).ref,
        skillName: SKILL_NAME,
        activityTypeKey: ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
        activityTypeName: ACTIVITY_TYPE_OBJECT.name,
        moduleKey: MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
      }
      this.store.addItem(activity, this.data.MODULE, true, (success, res) => {
        this.data.ITEM = activity;
        this.snackBar.open("Group has been saved successful.", "Done", { duration: 1000 });
        if (!isNew) {
          this.dialogRef.close('no')
          return;
        }
        this.form.reset();
        this.form.enable();
        this.form.patchValue({ isFill: false })
        this.processNew = false;
        this.processClose = false;
        this.isCreate = false;
        this.inputEl.nativeElement.focus()
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}